export default "__VITE_ASSET__v9iSAXdL__"